import Flag from "react-flags"
import { t } from "i18next"

import { Typography } from "../../../Typography/typography"
import styles from './EmployerPortalJobDetail.module.css'
import { GenderIcon, UserDummyImg } from "../../../../assets/images/icons"
import userAvatarPlaceholder from '../../../../assets/images/other/user_avatar_placeholder.png';

export const bestMatchUI = (similarJobs, navigate) => {
    return (
        <div className={styles.applicationWrapper}>
            <Typography title={t('general.UI.best_match')} weight={'600'} fontSize={16} />
            <div className={styles.applicationData}>
                {similarJobs?.length > 0 && similarJobs?.map((item, index) => {
                    const name = item?.application?.job_seeker?.first_name + ' ' + item?.application?.job_seeker?.last_name
                    const profile_image = item?.application?.job_seeker?.profile_image ? process.env.REACT_APP_UPLOADS_PATH + item?.application?.job_seeker?.profile_image : UserDummyImg
                    const gender = item?.application?.job_seeker?.gender
                    const country = item?.application?.job_seeker?.country
                    return (
                        <div className={styles.matchListContainer}>
                            <div className={styles.profileIcon}>
                                <img src={profile_image} className={styles.userImg}
                                    onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop
                                        e.target.src = userAvatarPlaceholder; // Set fallback image
                                    }} style={{ objectFit: "cover" }} />
                            </div>
                            <div className={styles.matchListBody}
                                onClick={() => navigate(`/jobseekers/${item?.application?.job_seeker.slug}`)}
                            >
                                <Typography title={name} weight={'600'} fontSize={14} />
                                <div className={styles.flagContainer}>
                                    {country &&
                                        <>
                                            <div>
                                                <Flag
                                                    name={country}
                                                    format="svg"
                                                    shiny={false}
                                                    basePath="/vendor/flags"
                                                />
                                                <span>{t('general.country.' + country)}</span>
                                            </div>
                                            <div className={styles.saperatorGender}></div>
                                        </>
                                    }
                                    <div>
                                        <img src={GenderIcon} alt={`pasport icon`}
                                            className={styles.icon}
                                        />
                                        <span>
                                            <Typography title={gender} textTransform={'capitalize'} color={'#6D6D6D'} fontSize={13} weight={400} />
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

        </div>
    )
}